import { render, staticRenderFns } from "./TruncateParagraph.vue?vue&type=template&id=257e91c8"
import script from "./TruncateParagraph.vue?vue&type=script&lang=js"
export * from "./TruncateParagraph.vue?vue&type=script&lang=js"
import style0 from "./TruncateParagraph.vue?vue&type=style&index=0&id=257e91c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports